"use client";

import { displayValue } from "@/components/OtherBetsDropdown";
import { trendClass } from "./BetOKTrendUtils";

export default function BetOKThreeColSection({ title, items, width = "kbv-v25-odt-item--50" }) {
  return (
    <div className={`kbv-v25-odt-item ${width}`}>
      <div className="kbv-v25-odt-title">
        <span>{title}</span>
      </div>
      <div className="kbv-v25-odt-odds-list">
        {items.map((item, i) => (
          <div key={i}>
            <div className="kbv-v25-odt-label">{item.label}</div>
            <div className={`kbv-v25-odt-odds ${trendClass(item.trend)}`}>
              {displayValue(item.value)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
